import { render, staticRenderFns } from "./acilisKarti.vue?vue&type=template&id=b4997438&scoped=true&"
import script from "./acilisKarti.vue?vue&type=script&lang=js&"
export * from "./acilisKarti.vue?vue&type=script&lang=js&"
import style0 from "./acilisKarti.vue?vue&type=style&index=0&id=b4997438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4997438",
  null
  
)

export default component.exports